import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'

import App from './App.vue'
import router from './router'
import i18n from './locales'
import { useAuthStore } from './stores/auth'
import { api } from './services/api'
import { loadMobilePublicConfig } from './services/mobileConfig'
import { initializeNativeShell } from './utils/nativeBootstrap'
import { registerDeepLinkHandler } from './utils/deepLinks'
import { registerPushTapHandler } from './utils/pushNavigation'
import { registerLocalNotificationTapHandler } from './utils/localNotificationNavigation'
import {
  bootstrapPrayerNotifications,
  registerPrayerScheduleLifecycle,
} from './services/prayerNotificationScheduler'
import { isNativePlatform } from './utils/platform'

import './styles/app.css'

async function bootstrap() {
  await initializeNativeShell()

  const app = createApp(App)
  const pinia = createPinia()
  const head = createHead()

  app.use(pinia)
  app.use(head)

  const authStore = useAuthStore()
  authStore.initializeAuth()

  // Load OAuth + Firebase public config from API (falls back to build-time env)
  await loadMobilePublicConfig()
  await api.restoreSession()

  app.use(router)
  app.use(i18n)

  registerDeepLinkHandler(router)
  registerPushTapHandler(router)
  registerLocalNotificationTapHandler(router)

  if (isNativePlatform) {
    const geoModule = await import('./composables/useGeolocation')
    const geo = geoModule.useGeolocation()
    registerPrayerScheduleLifecycle(
      async () => {
        await geo.locate()
        return { lat: geo.latitude.value, lng: geo.longitude.value }
      },
      () => useAuthStore().isAuthenticated,
      () => i18n.global.locale.value,
    )
    void bootstrapPrayerNotifications(
      async () => {
        await geo.locate()
        return { lat: geo.latitude.value, lng: geo.longitude.value }
      },
      authStore.isAuthenticated,
      i18n.global.locale.value,
    )
  }

  app.mount('#app')
}

bootstrap()
